'use strict';

import $ from 'jquery';
import UserValidator from '@/js/modules/user_validator';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    $(document).on('submit', '.lml-page-box__form', (e) => {
      let error = '';
      const $form = $(e.target);
      const name = $form.find('input[type=text]').val();
      const email = $form.find('input[type=email]').val();
      const companyType = $form.find('.field--company-type').val();
      const launchDate = $form.find('.field--business-launch-date').val();

      $form.find('.field').removeClass('field--error');

      error = companyType === '' ? "Question can't be blank" : '';
      $form
        .find('.form-error--lml-page-company-type')
        .text(error)
        .css('display', error === '' ? 'none' : 'block');

      error = launchDate === '' ? "Question can't be blank" : '';
      $form
        .find('.form-error--lml-page-business-launch-date')
        .text(error)
        .css('display', error === '' ? 'none' : 'block');

      error = UserValidator.validateName(name);
      $form
        .find('.form-error--lml-page-name')
        .text(error)
        .css('display', error === '' ? 'none' : 'block');

      error = UserValidator.validateEmail(email);
      $form
        .find('.form-error--lml-page-email')
        .text(error)
        .css('display', error === '' ? 'none' : 'block');

      if ($('.form-error:visible').length) {
        $('.form-error:visible').prev('.field').addClass('field--error');
        $('.form-error:visible:first').prev('.field').focus();

        return false;
      } else {
        $.post($form.attr('action'), $form.serialize())
          .done(() => {
            if ($form.hasClass('lml-page-box__form--free-books')) {
              $form.closest('.lml-page-box__lead-form-container').addClass('hide');
              $form
                .closest('.lml-page-box__pdf-form-container')
                .find('.lml-page-box__lead-success')
                .removeClass('hide');
            } else if ($form.hasClass('lml-page-box__form--hp-footer')) {
              $form.addClass('hide');
              $form.siblings('.lml-page-box__success-container').removeClass('hide');
            } else {
              let confirmationPage = 'confirmed';
              const locationPathname = window.location.pathname.split('/')[1];

              if (['edesign-book', 'affiliate-book'].includes(locationPathname)) {
                confirmationPage = 'sales';
              } else if (['moodboards', 'chatgpt-emails'].includes(locationPathname)) {
                confirmationPage = 'thank-you';
              }
              window.location.href = `/${locationPathname}/${confirmationPage}`;
              if (locationPathname === 'profitable-packages-guide') {
                window.open($('.lml-page-box--pdf-url').data().pdfUrl, '_blank');
              }
            }
          })
          .fail((xhr) => {
            if (xhr.responseJSON.email_error !== undefined) {
              $('#lead_email').addClass('field--error');
              $form
                .find('.form-error--lml-page-email')
                .text(xhr.responseJSON.email_error)
                .css('display', 'block');
            } else {
              alert('Error occured');
            }
          });
        return false;
      }
    });
  });

  $(document).on($.modal.OPEN, '.modal--lml-form', () => {
    $('.lml-page-box__form').find('.field').first().focus();
  });

  if (window.location.pathname === '/r/qccs') {
    $('.tour').find('.h-s-button').text('Get 4 Months Free').attr('href', '/plans?promo=qc4free');
  }

  if ($('body').is('#lml-page-edesign-book, #lml-page-affiliate-book')) {
    $(document).on('mouseout', function (e) {
      e = e ? e : window.event;
      if (e.target.tagName.toLowerCase() === 'input') {
        return false;
      }
      const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
      if (e.clientX >= vpWidth - 50) {
        return false;
      }
      if (e.clientY >= 50) {
        return false;
      }
      const from = e.relatedTarget || e.toElement;
      const exitModalIndicator = $('body').attr('id');

      if (!from && document.cookie.indexOf(exitModalIndicator) < 0) {
        // populate form modal with exit elements and launch it
        $('.modal--lml-form')
          .addClass('modal--lml-ebook-exit')
          .removeClass('modal--lml-form-main')
          .prepend($('.lml-ebook-exit-modal-content').show())
          .find('.lml-page-box__form')
          .prepend(
            `<div class="lml-page-box__form-header">
            <strong>
              Get your <span class="lml-page-box__form-header-red">free</span> copy!
            </strong>
          </div>`
          )
          .end()
          .find('.p-button--lml-pdf')
          .addClass('p-button--lml-pdf-ebook-exit')
          .end()
          .find('.field')
          .addClass('field--exit-modal')
          .end()
          .modal();
        document.cookie = exitModalIndicator;
      }
    });

    // remove exit elements form exit modal once it is closed
    $('.modal--lml-form').on($.modal.BEFORE_CLOSE, function () {
      if ($('.modal--lml-form').hasClass('modal--lml-ebook-exit')) {
        $('.modal--lml-ebook-exit')
          .removeClass('modal--lml-ebook-exit')
          .addClass('modal--lml-form-main');
        $('.lml-ebook-exit-modal-content').remove();
        $('.lml-page-box__form-header').remove();
        $('.field').removeClass('field--exit-modal');
      }
    });
  }

  if (window.location.pathname === '/edesign-event-2023/confirmed') {
    $('#edesign-business-thank-you').modal();
  }

  // add tracking link to header register button for dsa landing page
  if (window.location.pathname === '/r/dsa') {
    const RegisterButtonUrl = $('.main-nav__register-button').attr('href');
    $('.main-nav__register-button').attr('href', `${RegisterButtonUrl}?rfsn=7130829.ef07b0`);
  }
});
